/* eslint-disable */
import {
    getToken,
    getAdminId,
} from "../../../utils/auth";
// import { $NOT_NETWORK } from '../../utils/errorCode'
import { Message } from "element-ui";
import axios from 'axios'
import https from "../../../utils/http";
let http = https.https
const state = {
};

// getters
const getters = {
};

// mutations
const mutations = {
    
};

// actions
const actions = {
    GetTreeData ({ commit }, data) {
        data.ADMIN_ID = getAdminId();
        data.ADMIN_TOKEN = getToken();
        return axios.post(http + '/enum/show_enum', data).then((res) => {
            return res.data
        })
    },
    GetTreeDataItem ({ commit }, data) {
        data.ADMIN_ID = getAdminId();
        data.ADMIN_TOKEN = getToken();
        return axios.post(http + '/enum/show_enums', data).then((res) => {
            return res.data
        })
    },
    // 新增
    SaveData ({ commit }, data) {
        data.ADMIN_ID = getAdminId();
        data.ADMIN_TOKEN = getToken();
        return axios.post(http + '/enum/edit_Enum', data).then((res) => {
            return res.data
        })
    },
    // 新增子集
    SaveDatas ({ commit }, data) {
        data.ADMIN_ID = getAdminId();
        data.ADMIN_TOKEN = getToken();
        return axios.post(http + '/enum/edit_Enums', data).then((res) => {
            return res.data
        })
    },
    // 枚举排序
    SortEnum ({ commit }, data) {
        data.ADMIN_ID = getAdminId();
        data.ADMIN_TOKEN = getToken();
        return axios.post(http + '/enum/sort_enums', data).then((res) => {
            console.log(res)
        })
    },
    Remove ({ commit }, data) {
        data.ADMIN_ID = getAdminId();
        data.ADMIN_TOKEN = getToken();
        return axios.post(http + '/enum/delete_enum', data).then((res) => {
            return res.data
        })
    },
    Removes ({ commit }, data) {
        data.ADMIN_ID = getAdminId();
        data.ADMIN_TOKEN = getToken();
        return axios.post(http + '/enum/delete_enums', data).then((res) => {
            return res.data
        })
    },
    // 批量提交
    AddEnum ({ commit }, data) {
        data.ADMIN_ID = getAdminId();
        data.ADMIN_TOKEN = getToken();
        return axios.post(http + '/Enum/add_Enums', data).then((res) => {
            return res.data
        })
    }
};

const EnumerationManagementModule = {
    state,
    getters,
    actions,
    mutations
}
export default EnumerationManagementModule
